export default "__VITE_ASSET__DzwgpO5C__"